/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteRetainerPeriodInput = {|
  id?: ?string,
  projectId?: ?string,
  keepRollovers?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteRetainerPeriodMutationVariables = {|
  input: DeleteRetainerPeriodInput
|};
export type deleteRetainerPeriodMutationResponse = {|
  +deleteRetainerPeriod: ?{|
    +deletedRetainerPeriodId: ?string
  |}
|};
export type deleteRetainerPeriodMutation = {|
  variables: deleteRetainerPeriodMutationVariables,
  response: deleteRetainerPeriodMutationResponse,
|};
*/


/*
mutation deleteRetainerPeriodMutation(
  $input: DeleteRetainerPeriodInput!
) {
  deleteRetainerPeriod(input: $input) {
    deletedRetainerPeriodId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRetainerPeriodInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRetainerPeriodPayload",
    "kind": "LinkedField",
    "name": "deleteRetainerPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRetainerPeriodId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRetainerPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRetainerPeriodMutation(\n  $input: DeleteRetainerPeriodInput!\n) {\n  deleteRetainerPeriod(input: $input) {\n    deletedRetainerPeriodId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c362ce68899dfa6fb14ec688d092b7be';

module.exports = node;
